<template lang="pug">
  v-container(grid-list-md v-if="!$root.$children[0].loading")
    v-flex(md12)
      v-card.elevation-12

        v-toolbar(dark color="primary" dense)
          v-toolbar-title Reporte Servicios {{ driverName }}
          v-spacer
          v-btn(@click="$router.push('/reporte')" flat)
            | Volver
            v-icon(right) undo
          v-btn(@click="closeSession()" flat)
            | Cerrar sesión
            v-icon(right) power_settings_new

        v-card-text
          v-layout(row wrap)
            v-flex(md2)
              v-select(
                v-model="month = $route.params.month"
                label="Mes"
                :items="getMonths")
            v-flex(md2)
              v-select(
              v-model="year = $route.params.year"
              label="Año"
              :items="getYears")

        v-card-text
          table(width="100%" align="center")
            thead
              tr
                th #
                th Pagado
                th Fecha
                th Hora
                th ID Pago
                th Servicio
                th Valor
            tbody
              tr(v-for="(driverServices, key) in servicesDriverIdParams")
                td(align="center") {{ key + 1 }}
                td(align="center")
                  v-icon(v-if="driverServices.paid === 0" style="color: #990006") close
                  v-icon(v-if="driverServices.paid === 1" style="color: #009900") check
                  v-icon(v-if="driverServices.paid === 2" style="color: #ceb300") help
                td(align="center") {{ driverServices.date }}
                td(align="center") {{ driverServices.hour_end }}
                td(align="center"): span.link-name(@click="$router.push('/servicio/' + driverServices.id_pay)") {{ driverServices.id_pay }}
                td(align="center") {{ driverServices.type }}
                td(align="center") {{ driverServices.value | price }}

          table.mt-5.dense(width="400" align="center" style="margin: auto")
            thead
              tr
                th
                th Cantidad
                th Monto
            tbody
              tr
                td(align="center"): strong Recos
                td(align="center") {{ countRecos(servicesDriverIdParams) }}
                td(align="center") {{ servicesPrice.reco | price }}
                tr
                td(align="center"): strong Zarpes
                td(align="center") {{ countZarpe(servicesDriverIdParams) }}
                td(align="center") {{ servicesPrice.zarpe | price }}
                tr
                td(align="center"): strong RTX
                td(align="center") {{ countRtx(servicesDriverIdParams) }}
                td(align="center") {{ servicesPrice.rtx | price }}
              tr
                td(align="center"): strong Total
                td(align="center") {{ servicesDriverIdParams.length }}
                td(align="center") {{ allServicesTotalMount | price }}
              tr
                td(align="center"): strong Descuento
                td(align="center") 20%
                td(align="center") {{ allServicesTotalMount * 0.2 | price }}
              tr
                td(align="center"): strong Liquido a pagar
                td(align="center") 80%
                td(align="center") {{ allServicesTotalMount * 0.8 | price }}

</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  moment.locale('es')

  export default {
    name: 'reportDriver',
    data: () => ({
      month: moment().format('MMMM'),
      year: parseInt(moment().format('gggg')),
      drivers: [],
      services: []
    }),
    created () {
      this.$route.params.year = parseInt(this.$route.params.year)
      this.moment = moment.locale('es')
      this.$root.$children[0].loading = true
      if (!localStorage.getItem('token')) {
        this.$router.push('/')
      } else {
        this.loadData()
      }
    },
    computed: {
      getYears () {
        let years = []
        for (let year = 2017; year <= parseInt(moment().format('gggg')); year++) {
          years.push(year)
        }
        return years
      },
      getMonths () {
        let months = []
        for (let month = 1; month <= 12; month++) {
          months.push(moment(month, 'M').format('MMMM'))
        }
        return months
      },
      allServicesTotalMount () {
        if (!this.services.length) return '$ 0'
        return this.services
          .map(service => service.driver_id === parseInt(this.$route.params.driverID) ? service.value : 0)
          .reduce((oldService, currentService) => oldService + currentService)
      },
      driverName () {
        if (this.drivers[this.$route.params.driverID]) {
          let driver = this.drivers[this.$route.params.driverID][0]
          return driver.names + ' ' + driver.last_names
        }
      },
      servicesDriverIdParams () {
        return _.groupBy(this.services, 'driver_id')[this.$route.params.driverID] || []
      },
      servicesPrice () {
        let services = {
          reco: 0,
          zarpe: 0,
          rtx: 0
        }
        let servicesByType = _.groupBy(this.servicesDriverIdParams, 'type')
        if (servicesByType.reco) {
          services.reco = servicesByType.reco
            .map(service => service.driver_id === parseInt(this.$route.params.driverID) ? service.value : 0)
            .reduce((oldService, currentService) => oldService + currentService)
        }
        if (servicesByType.zarpe) {
          services.zarpe = servicesByType.zarpe
            .map(service => service.driver_id === parseInt(this.$route.params.driverID) ? service.value : 0)
            .reduce((oldService, currentService) => oldService + currentService)
        }
        if (servicesByType.rtx_reco) {
          services.rtx += servicesByType.rtx_reco
            .map(service => service.driver_id === parseInt(this.$route.params.driverID) ? service.value : 0)
            .reduce((oldService, currentService) => oldService + currentService)
        }
        if (servicesByType.rtx_zarpe) {
          services.rtx += servicesByType.rtx_zarpe
            .map(service => service.driver_id === parseInt(this.$route.params.driverID) ? service.value : 0)
            .reduce((oldService, currentService) => oldService + currentService)
        }
        return services
      }
    },
    methods: {
      loadData () {
        this.$http.get('services', {
          params: {
            month: moment(this.month, 'MMMM').format('M'),
            year: this.year,
            vehicleID: localStorage.getItem('vehicleID')
          }
        }).then(res => {
          this.drivers = _.groupBy(res.body, 'driver_id')
          this.services = res.body
          this.$root.$children[0].loading = false
        }).catch(res => {
          this.$router.push('/')
          this.$root.$children[0].loading = false
        })
      },
      countRecos (services) {
        let counter = 0
        services.forEach(service => {
          if (service.type === 'reco') counter++
        })
        return counter
      },
      countZarpe (services) {
        let counter = 0
        services.forEach(service => {
          if (service.type === 'zarpe') counter++
        })
        return counter
      },
      countRtx (services) {
        let counter = 0
        services.forEach(service => {
          if (service.type === 'rtx_reco' || service.type === 'rtx_zarpe') counter++
        })
        return counter
      },
      countServicesPrice (services) {
        let counter = 0
        services.forEach(service => {
          counter += service.value
        })
        return '$ ' + new Intl.NumberFormat('es-CL').format(counter)
      },
      closeSession () {
        localStorage.removeItem('token')
        localStorage.removeItem('vehicleID')
        setTimeout(() => {
          window.location.href = '/'
        }, 1000)
      }
    },
    watch: {
      month () {
        this.loadData()
      },
      year () {
        this.loadData()
      }
    },
    filters: {
      price (value) {
        return '$ ' + new Intl.NumberFormat('es-CL').format(parseInt(value))
      }
    }
  }
</script>

<style scoped lang="sass"></style>



// WEBPACK FOOTER //
// src/pages/reportDriver.vue